module.exports = __webpack_public_path__ + "static/banner_home_mobile2-9c938765c7e19f6a9ece9568a1dc2094.jpg";